/**
 * 区分 personnelStatus（personnel.personnel_status）
 * 出典：要件書 5.2
 */
export const PERSONNEL_STATUS_VALUES = ['preContract', 'active', 'standby', 'ended'] as const;

export type PersonnelStatus = (typeof PERSONNEL_STATUS_VALUES)[number];

export const PERSONNEL_STATUS_LABELS: Readonly<Record<PersonnelStatus, string>> = {
  preContract: '契約前',
  active: '稼働中',
  standby: '待機中',
  ended: '終了',
};
